import Skeleton from 'react-loading-skeleton';
import styles from './TextInfo.module.scss';
import classNames from 'classnames';
import { EmptyCell } from '@casops/components/tables/formatters/genericFormatters';

export interface TextInfoProps {
  label: string;
  value?: string;
  onClick?: () => void;
}

export default function TextInfo({ label, value, onClick }: TextInfoProps) {
  const isLoading = value === undefined;
  const isClickable = typeof onClick === 'function';
  const isValueEmptyCell = value === EmptyCell;

  return (
    <div className={styles.container}>
      <div className={styles.label}>
        {isLoading ? <Skeleton width="50px" height="16px" /> : label}
      </div>
      {isLoading ? (
        <Skeleton width="120px" height="20px" />
      ) : isValueEmptyCell ? (
        <div className={styles.value}>{value}</div>
      ) : (
        <div
          className={classNames(styles.value, isClickable && styles.clickable)}
          onClick={onClick}
          role={isClickable ? 'button' : undefined}
        >
          {value}
        </div>
      )}
    </div>
  );
}
